import { Component, Input } from '@angular/core';
import {
  faFacebook,
  faWhatsapp,
  faLinkedin,
  faYoutube,
  faTiktok,
} from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faAddressBook } from '@fortawesome/free-solid-svg-icons';
import { FetchDataService } from 'src/app/shared/services/fetch-data.service';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { environment } from 'src/environments/environment';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  icons: { [key: string]: IconProp } = {
    faFacebook: faFacebook,
    faWhatsapp: faWhatsapp,
    faLinkedin: faLinkedin,
    faEnvelope: faEnvelope,
    faInstagram: faInstagram,
    faYoutube: faYoutube,
    faTiktok: faTiktok,
    faAddressBook: faAddressBook,
  };

  @Input() lang!: string;
  soicalMediaLinks: any = [];
  language!: string;
  imageSrc!: string;
  witharc!: boolean;
  logoPath!: string;
  arcPath!: string;
  locations!: string;
  emails!: string;

  constructor(
    private fetchDataService: FetchDataService,
    library: FaIconLibrary
  ) {
    this.logoPath =
      '../../../assets/' + environment.projectName + '/media/footer/logo.png';
    this.arcPath =
      '../../../assets/' +
      environment.projectName +
      '/media/footer/wavesdown.png';
    library.addIcons(
      faFacebook,
      faWhatsapp,
      faLinkedin,
      faEnvelope,
      faAddressBook
    );
  }

  ngOnInit(): void {
    this.fetchDataService.getJSONfooter().subscribe({
      next: (data: any) => {
        this.imageSrc = data.imageSrc;
        this.witharc = data.witharc;
        this.locations = data.location;
        this.emails = data.email;
      },
      error: (err) => {
        console.error('Error fetching services:', err);
      },
    });
    this.fetchDataService.getSocialLinkes().subscribe({
      next: (data: any) => {
        this.soicalMediaLinks = data.soicalMediaLinks;
      },
      error: (err) => {
        console.error('Error fetching services:', err);
      },
    });
  }
}
